import { render, staticRenderFns } from "./PersonalDataCheckbox.vue?vue&type=template&id=46865184&scoped=true"
import script from "./PersonalDataCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalDataCheckbox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PersonalDataCheckbox.vue?vue&type=style&index=0&id=46865184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46865184",
  null
  
)

export default component.exports